import BaseService from '../common/BaseService';
import { COMMUNICATION_PREFERENCES, LANGUAGES } from '../common/endpoints';
import { AxiosResponse } from 'axios';

export default class IndividualPortalService extends BaseService {
    constructor(props) {
        super(props);
    }

    getCommunicationPreferences(): Promise<any> {
        return this.client.get(COMMUNICATION_PREFERENCES).then((response: AxiosResponse) => response.data);
    }

    getLanguages() {
        return this.client.get(LANGUAGES).then(response => response.data);
    }
}